const pageNameKey = "dropDownLanguage";

export const dropDownLanguageEn = {
  [pageNameKey]: {
    englishLabel: "English",
    germanLabel: "German",
    chineseLabel: "Chinese",
    italianLabel: "Italian",
    spanishLabel: "Spanish",
    portugueseBrazilianLabel: "Portuguese",
    dutchLabel: "Dutch",
    turkishLabel: "Turkish",
  },
};

export const dropDownLanguagePtBr = {
  [pageNameKey]: {
    englishLabel: "Inglês",
    germanLabel: "Alemão",
    chineseLabel: "Chinês",
    italianLabel: "Italiano",
    spanishLabel: "Espanhol",
    portugueseBrazilianLabel: "Português",
    dutchLabel: "Holandês",
    turkishLabel: "Turco",
  },
};

export const dropDownLanguageDe = {
  [pageNameKey]: {
    englishLabel: "Englisch",
    germanLabel: "Deutsch",
    chineseLabel: "Chinesisch",
    italianLabel: "Italienisch",
    spanishLabel: "Spanisch",
    portugueseBrazilianLabel: "Portugiesisch",
    dutchLabel: "Niederländisch",
    turkishLabel: "Türkisch",
  },
};

export const dropDownLanguageZhHans = {
  [pageNameKey]: {
    englishLabel: "英语",
    germanLabel: "德语",
    chineseLabel: "汉语",
    italianLabel: "意大利语",
    spanishLabel: "西班牙语",
    portugueseBrazilianLabel: "葡萄牙语",
    dutchLabel: "荷兰语",
    turkishLabel: "土耳其语",
  },
};

export const dropDownLanguageIt = {
  [pageNameKey]: {
    englishLabel: "Inglese",
    germanLabel: "Tedesco",
    chineseLabel: "Cinese",
    italianLabel: "Italiano",
    spanishLabel: "Spagnolo",
    portugueseBrazilianLabel: "Portoghese",
    dutchLabel: "Olandese",
    turkishLabel: "Turco",
  },
};

export const dropDownLanguageEs = {
  [pageNameKey]: {
    englishLabel: "Inglés",
    germanLabel: "Alemán",
    chineseLabel: "Chino",
    italianLabel: "Italiano",
    spanishLabel: "Español",
    portugueseBrazilianLabel: "Portugués",
    dutchLabel: "Holandés",
    turkishLabel: "Turco",
  },
};

export const dropDownLanguageNl = {
  [pageNameKey]: {
    chineseLabel: "Chinees",
    englishLabel: "Engels",
    germanLabel: "Duits",
    italianLabel: "Italiaans",
    portugueseBrazilianLabel: "Portugees",
    spanishLabel: "Spaans",
    dutchLabel: "Nederlands",
    turkishLabel: "Turks",
  },
};

export const dropDownLanguageTr = {
  [pageNameKey]: {
    chineseLabel: "Çince",
    dutchLabel: "Flemenkçe",
    englishLabel: "İngilizce",
    germanLabel: "Almanca",
    italianLabel: "İtalyan",
    portugueseBrazilianLabel: "Portekizce (Br)",
    spanishLabel: "İspanyolca",
    turkishLabel: "Türkçe",
  },
};
